<template>
  <div>
    <Modal
      ref="modal"
      :title="isPreview ? 'Preview & Send E-signature' : 'Select E-signature Template'"
      :action="action"
      action-color="indigo"
      @close-modal="handleCancel"
      @handle-action="handleSend"
    >
      <RadioSelect v-if="loaded && !isPreview" v-model="selectedTemplate" class="mt-4" :options="templatesForSelect" />
      <div v-if="submission">
        <docuseal-form id="docusealForm" :data-src="submission.embed_src" data-preview="true" data-with-title="false">
        </docuseal-form>
      </div>
    </Modal>
  </div>
</template>

<script>
import Modal from '../shared/Modal.vue';
import RadioSelect from '../shared/RadioSelect.vue';
import { useCurrentUserStore } from '@/stores/currentUser.ts';
import { useLoadingSpinnerStore } from '@/stores/loadingSpinner.ts';
import { toast } from 'vue-sonner';

export default {
  components: {
    Modal,
    RadioSelect,
  },
  props: ['record'],
  setup() {
    const currentUserStore = useCurrentUserStore();
    const loadingSpinnerStore = useLoadingSpinnerStore();
    return { currentUserStore, loadingSpinnerStore };
  },
  data() {
    return {
      selectedTemplate: '',
      templates: [],
      templatesForSelect: [],
      companySigner: this.currentUserStore.currentUserAccountDetails.username,
      submission: null,
      isPreview: false,
      action: 'Preview',
      loaded: false,
    };
  },
  mounted() {
    this.getTemplates();
  },
  methods: {
    handleSend() {
      const self = this;
      this.loadingSpinnerStore.showLocalLoadingSpinner();
      self.isPreview = !self.isPreview;
      fetch(`/api/esignature_templates/send_for_signature/`, {
        method: 'POST',
        body: JSON.stringify({
          id: self.record.id,
          is_preview: self.isPreview,
          template_id: self.templatesForSelect.find(temp => temp.label === self.selectedTemplate).id,
        }),
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': document.querySelectorAll('[name="csrf-token"]')[0]?.content ?? '',
        },
      })
        .then(response => {
          return response.json();
        })
        .then(data => {
          self.submission = data.record;
          this.loadingSpinnerStore.hideLocalLoadingSpinner();
          if (!self.isPreview) {
            if (data.status != 'error') {
              this.$emit('handleSubmit');
              toast.success('Esignature successfully sent!', {
                action: { label: 'Dismiss' },
                description: 'Your esignature template has been successfully send for signature.',
              });
            } else {
              toast.error('Esignature send error', {
                action: { label: 'Dismiss' },
                description: data.message,
              });
            }
          } else {
            self.action = 'Send';
            if (data.status == 'error') {
              toast.error('Esignature send error', {
                action: { label: 'Dismiss' },
                description: data.message,
              });
            }
          }
        });
    },
    handleCancel() {
      this.$emit('handleCancel');
    },
    getTemplates() {
      const self = this;
      fetch(`/api/esignature_templates/`)
        .then(response => {
          return response.json();
        })
        .then(data => {
          for (let template of data.records) {
            self.templates.push({
              id: template.id,
              name: template.name,
            });
            self.templatesForSelect.push({
              id: template.id,
              label: template.name,
              description: '',
            });
          }
          self.selectedTemplate = self.templatesForSelect[0].label;
          self.loaded = true;
        });
    },
  },
};
</script>
